module.exports = __webpack_public_path__ + "static/5-289aab31e0e4d2d94b0b46c978d97c56.jpg";